import type { SessionEndpoints } from '@/session/endpointManifest';
import { readCurrentOrganizationTimezoneCache, updateCurrentOrganizationTimezoneCache } from '@/session/organizationTimezoneCache';
import { operationRequirement, SessionTransitionError, type OperationContext } from '@/session/operation';

export const getCurrentOrganizationTimezone = async (endpoints: SessionEndpoints, operation: OperationContext): Promise<string> => {
  const cachedTimezone = readCurrentOrganizationTimezoneCache(operation.organization, operation.subject);
  if (cachedTimezone) return cachedTimezone;
  if (!operation.isScopeCurrent()) throw new SessionTransitionError();

  const response = await endpoints.organizationData.getCurrentOrganizationSettings({
    signal: operation.scopeSignal,
    operationRequirement: operationRequirement(operation, 'scope'),
  });
  if (!operation.isScopeCurrent()) throw new SessionTransitionError();

  if (response.isError) {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  const settings = response.result;
  if (settings && typeof settings === 'object') {
    const timezone = settings.time_zone || settings.timezone;
    if (timezone) {
      updateCurrentOrganizationTimezoneCache(timezone, operation.organization, operation.subject);
      return timezone;
    }
  }

  // Fallback to browser timezone
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
